import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    titleContainer: {
        flexDirection: "column"
    },
    tabBarContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    tabContentContainer: {
        width: "100%"
    },
    container: {
        width: "100%",
        flex: 1
    },
    pageContent: {
        width: "100%"
    }
});
export default stylesheet;
